export default __webpack_public_path__ + "static/media/1.19df81b9.webp";